// Vlaams (Flemish) – eigenständige Übersetzung
import nl from "./nl";

const nlBE: typeof nl = {
  ...nl,
  common: {
    ...nl.common,
    loading: "Aan het laden...",
    pleaseWait: "Even geduld aub...",
    craftBusiness: "Ambachtelijk bedrijf",
    forCraftBusinesses: "Voor ambachtelijke bedrijven",
  },
  footer: {
    ...nl.footer,
    copyright: "\u00A9 {{year}} CRAFTFINDUS. Voor ambachtelijke bedrijven in Belgi\u00EB, Duitsland, Oostenrijk en Zwitserland.",
  },
  home: {
    ...nl.home,
    heroDesc: "Beschrijf uw project. Wij vinden 3 tot 5 passende ambachtelijke bedrijven voor u. Gratis, binnen 24 uur.",
    heroCta: "Gratis vakman vinden",
    heroCtaCraft: "Ik ben een ambachtelijk bedrijf",
  },
  inquiry: {
    ...nl.inquiry,
    contactPhonePlaceholder: "+32 ...",
  },
  contact: {
    ...nl.contact,
    emailPlaceholder: "uw@email.be",
  },
  auth: {
    ...nl.auth,
    emailPlaceholder: "uw@email.be",
  },
};

export default nlBE;
